// My events: your upcoming starred events, soonest first; past ones drop off (spec item 9). Port of
// web/profile-ui.js myEventsView. A row looks like a search result, with its star.
import { T } from "../../shared/config";
import { Icon } from "../../shared/icons";
import { RULES } from "../../shared/rules";
import { distance } from "../../data/format";
import { byStart } from "../../state/filtered";
import { eventById, useFeed } from "../../state/feed";
import { useNow } from "../../state/clock";
import { useProfileView, useProfileEvents } from "../../state/profile";
import { closeSheet, moveMap, openSheet, useView } from "../../state/view";
import { EmojiBadge } from "../../ui/EmojiBadge";
import { StarButton } from "./StarButtons";
import styles from "./profile.module.css";

export function MyEvents() {
  const stars = useProfileView().stars;
  useProfileEvents(); useFeed((s) => s.byId); // the events can arrive after the ids
  const now = useNow();
  const here = useView((s) => s.userLocation);
  const events = [...stars].map((id) => eventById(id)).filter((e): e is NonNullable<typeof e> => !!e && !RULES.hasEnded(e, now)).sort(byStart);
  return (
    <div id="my-events">
      <div className={styles["list-head"]}>
        <h3>{T("myEvents")}</h3>
        <button type="button" className={styles["close"]} aria-label={T("close")} onClick={closeSheet}><Icon name="x" /></button>
      </div>
      {events.length ? events.map((e) => {
        const label = RULES.timeLabel(e, now);
        const open = () => { moveMap({ lat: e.lat, lng: e.lng }, 15, true); openSheet({ kind: "event", id: e.id }); };
        return (
          <div key={e.id} className={styles["result"]} role="button" tabIndex={0} data-id={e.id} onClick={open}
            onKeyDown={(ev) => { if (ev.key === "Enter") open(); }}>
            <EmojiBadge event={e} />
            <span className={styles["result-text"]}>
              <div className={styles["t"]}>{e.title}</div>
              <div className={`${styles["rel"]} ${styles[`tone-${label.tone}`] ?? ""}`}>{label.text}</div>
              <div className={styles["meta"]}>{[e.venue_name, distance(e, here), RULES.admission(e)].filter(Boolean).join(" · ")}</div>
            </span>
            <StarButton event={e} />
          </div>
        );
      }) : (
        <div className={styles["empty"]}><b>{T("myEvents.emptyTitle")}</b>{T("myEvents.emptyText")}</div>
      )}
    </div>
  );
}
